var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text_page"},[_c('div',{staticClass:"page_top"},[_c('div',{staticClass:"page_top_con"},[_c('div',{on:{"click":_vm.closeBtn}},[_c('i',{staticClass:"el-icon-back"}),_c('span',[_vm._v("返回")])])])]),_c('div',{staticClass:"page_con"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlData)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }